import { render, staticRenderFns } from "./HomeContent.vue?vue&type=template&id=73012ecb&scoped=true&"
import script from "./HomeContent.vue?vue&type=script&lang=js&"
export * from "./HomeContent.vue?vue&type=script&lang=js&"
import style0 from "./HomeContent.vue?vue&type=style&index=0&id=73012ecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73012ecb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardSubtitle,VCol,VContainer,VImg,VRow,VSimpleTable})
